import { jsx as c, jsxs as V, Fragment as be } from "react/jsx-runtime";
import ve, { useState as z, useRef as D, useCallback as w, useEffect as me } from "react";
import { useFoundation as xe, raf as Le, useClassNames as re, createComponent as Ae, useId as ye, Tag as fe } from "@rmwc/base";
import { FloatingLabel as Oe } from "@rmwc/floating-label";
import { LineRipple as _e } from "@rmwc/line-ripple";
import { NotchedOutline as Fe } from "@rmwc/notched-outline";
import { Menu as Ne, MenuItem as pe, MenuItems as we, MenuSurfaceAnchor as Ve } from "@rmwc/menu";
import { ListGroup as Ee, ListGroupSubheader as Te, ListDivider as je } from "@rmwc/list";
import { MDCSelectFoundation as ke, cssClasses as ge, MDCSelectIconFoundation as qe } from "@material/select";
import { Icon as he } from "@rmwc/icon";
const Be = (e) => {
  const [n, f] = z(), [s, m] = z(!1), [a, h] = z(0), [C, y] = z(!1), [b, i] = z(!1), [p, g] = z(""), u = D(-1), W = (t) => {
    u.current = t;
  }, M = D(), E = (t) => {
    M.current = t;
  }, v = D(), O = (t) => {
    v.current = t;
  }, U = D(null), Q = (t) => {
    U.current = t;
  }, H = D(), ce = (t) => {
    H.current = t;
  }, J = D(), le = (t) => {
    J.current = t;
  }, T = D(!1), { foundation: l, ...Y } = xe({
    props: e,
    elements: {
      rootEl: !0,
      anchorEl: !0
    },
    foundation: ({ rootEl: t, anchorEl: R, getProps: L, emit: k }) => {
      const _ = () => !L().enhanced, X = () => {
        const o = () => {
          var r, d;
          return (_() ? Array.apply(
            null,
            (r = J.current) == null ? void 0 : r.options
          ) : (d = v.current) == null ? void 0 : d.items()) || [];
        }, F = (r) => r.getAttribute("data-value") || r.getAttribute("value") || "";
        return {
          setSelectedText: (r) => g(r),
          openMenu: () => {
            i(!0);
          },
          closeMenu: () => {
            i(!1);
          },
          getAnchorElement: () => U.current,
          setMenuAnchorElement: (r) => Q(r),
          setMenuAnchorCorner: (r) => {
            var d;
            return (d = v.current) == null ? void 0 : d.setAnchorCorner(r);
          },
          setMenuWrapFocus: (r) => {
          },
          focusMenuItemAtIndex: (r) => {
            var d;
            return (d = v.current) == null ? void 0 : d.focusItemAtIndex(r);
          },
          getMenuItemCount: () => o().length,
          getMenuItemValues: () => o().map(F) || [],
          getMenuItemTextAtIndex: (r) => o()[r].textContent,
          isSelectAnchorFocused: () => !!(R.ref && R.ref === document.activeElement),
          getSelectAnchorAttr: (r) => R.getProp(r),
          setSelectAnchorAttr: (r, d) => {
            if (r === "tabindex") {
              if (_())
                return;
              r = "tabIndex";
            }
            return R.setProp(r, d);
          },
          removeSelectAnchorAttr: (r) => {
            var d;
            (d = U.current) == null || d.removeAttribute(r);
          },
          addMenuClass: (r) => {
            var d, N, B;
            return (B = (N = (d = v.current) == null ? void 0 : d.getSurfaceElement()) == null ? void 0 : N.querySelector(".mdc-deprecated-list-item--activated")) == null ? void 0 : B.classList.add(r);
          },
          removeMenuClass: (r) => {
            var d, N, B;
            return (B = (N = (d = v.current) == null ? void 0 : d.getSurfaceElement()) == null ? void 0 : N.querySelector(".mdc-deprecated-list-item--activated")) == null ? void 0 : B.classList.remove(r);
          },
          getSelectedIndex: () => u.current,
          setSelectedIndex: (r) => W(r)
        };
      }, A = () => ({
        addClass: (o) => {
          t.addClass(o);
        },
        removeClass: (o) => {
          t.removeClass(o);
        },
        hasClass: (o) => t.hasClass(o),
        isRtl: () => t.ref && window.getComputedStyle(t.ref).getPropertyValue("direction") === "rtl",
        setRippleCenter: (o) => {
          h(o);
        },
        activateBottomLine: () => m(!0),
        deactivateBottomLine: () => m(!1),
        notifyChange: (o) => {
          T.current || k(
            "onChange",
            {
              index: u.current,
              value: o
            },
            !0
          );
        }
      }), ne = () => ({
        hasOutline: () => !!L().outlined,
        notchOutline: (o) => {
          f(o);
        },
        closeOutline: () => {
          f(void 0);
        }
      }), Me = () => ({
        hasLabel: () => !!L().label,
        floatLabel: (o) => {
          y(o);
        },
        getLabelWidth: () => {
          var o;
          return ((o = M.current) == null ? void 0 : o.getWidth()) || 0;
        },
        setLabelRequired: (o) => {
          var F;
          return (F = M.current) == null ? void 0 : F.setRequired(o);
        }
      }), Se = () => ({
        leadingIcon: H.current && H.current.getFoundation() || void 0
      }), I = new ke(
        {
          ...X(),
          ...A(),
          ...ne(),
          ...Me()
        },
        Se()
      ), q = I.adapter;
      I.layout = () => {
        (() => {
          const F = I.getValue();
          if (q.hasLabel()) {
            const r = !!L().placeholder || (F == null ? void 0 : F.length) > 0 || // As of MCW 8, we need to check for selectedIndex, else the label won't float when unfocused
            u.current > -1, d = q.hasClass(ge.FOCUSED), N = r || d, B = q.hasClass(ge.REQUIRED);
            I.notchOutline(N), q.floatLabel(N), q.setLabelRequired(B);
          }
        })();
      }, Object.defineProperty(I, "menuItemValues", {
        get: () => q.getMenuItemValues()
      });
      const Re = I.init.bind(I);
      return I.init = () => {
        T.current = !0, Re();
        const o = String(L().placeholder || "");
        !I.getValue() && o && q.setSelectedText(o), T.current = !1;
      }, I;
    }
  }), { rootEl: x } = Y, { onFocus: P } = e, oe = w(
    (t) => {
      P == null || P(t), l.handleFocus();
    },
    [P, l]
  ), { onBlur: $ } = e, ae = w(
    (t) => {
      $ == null || $(t), l.handleBlur();
    },
    [$, l]
  ), { onChange: K } = e, se = w(
    (t) => {
      K == null || K(t), l.handleChange();
    },
    [K, l]
  ), Z = w(
    (t) => {
      var k, _;
      if ((k = x.ref) != null && k.querySelector(".mdc-select--disabled"))
        return;
      if ((_ = x.ref) != null && _.querySelector(".mdc-menu-surface--open")) {
        l.handleMenuClosed();
        return;
      }
      const L = ((X) => {
        const A = X.target.getBoundingClientRect();
        return X.clientX - A.left;
      })(t);
      x.ref && x.ref.focus(), l.handleClick(L);
    },
    [l, x.ref]
  ), { onKeyDown: j } = e, de = w(
    (t) => {
      j == null || j(t), l.handleKeydown(t);
    },
    [l, j]
  ), ue = w(
    (t) => {
      u.current = t, l.handleMenuItemAction(t);
    },
    [l]
  ), ie = w(() => {
    l.handleMenuOpened();
  }, [l]), ee = w(() => {
    i(!1), l.handleMenuClosed();
  }, [l]), te = l.getValue(), S = e.value ?? (u.current === -1 ? e.defaultValue : void 0), G = Array.isArray(e.options) ? e.options.length : Object.values(e.options || {}).length;
  return me(() => {
    if (T.current = !0, S !== void 0 && S !== te) {
      const t = l.menuItemValues.indexOf(S);
      if (u.current = t, l.setValue(S || ""), l.menuItemValues.includes(S)) {
        const R = l.adapter.getMenuItemTextAtIndex(t);
        g(R);
      }
    }
    Le(() => {
      T.current = !1;
    });
  }, [S, te, G, l]), me(() => {
    l.setDisabled(!!e.disabled);
  }, [l, e.disabled]), me(() => {
    var t;
    x.ref && ((t = v.current) == null || t.setAnchorElement(x.ref));
  }, [x.ref]), {
    notchWidth: n,
    menuOpen: b,
    lineRippleActive: s,
    lineRippleCenter: a,
    floatLabel: C,
    selectedIndex: u.current,
    selectedTextContent: p,
    setFloatingLabel: E,
    setMenu: O,
    setLeadingIcon: ce,
    setNativeControl: le,
    handleFocus: oe,
    handleBlur: ae,
    handleClick: Z,
    handleChange: se,
    handleKeydown: de,
    handleMenuClosed: ee,
    handleMenuOpened: ie,
    handleMenuSelected: ue,
    ...Y
  };
}, De = (e) => {
  const { foundation: n, ...f } = xe({
    props: e,
    elements: { rootEl: !0 },
    api: ({
      foundation: s
    }) => ({
      getFoundation: () => s
    }),
    foundation: ({ rootEl: s, emit: m }) => new qe({
      getAttr: (a) => s.getProp(a),
      setAttr: (a, h) => s.setProp(a, h),
      removeAttr: (a) => s.removeProp(a),
      setContent: (a) => {
        s.ref && (s.ref.textContent = a);
      },
      registerInteractionHandler: (a, h) => s.addEventListener(a, h),
      deregisterInteractionHandler: (a, h) => s.removeEventListener(a, h),
      notifyIconAction: () => m("onClick", {}, !0)
    })
  });
  return { ...f };
}, We = function(n) {
  const { apiRef: f, ...s } = n, { rootEl: m } = De(n), a = re(n, ["mdc-select__icon"]);
  return /* @__PURE__ */ c(
    he,
    {
      ...m.props({
        ...s,
        className: a
      })
    }
  );
}, Ie = (e) => Array.isArray(e) && e[0] && typeof e[0] == "object" ? e.map((n) => {
  if (typeof n != "object")
    throw new Error(`Encountered non object for Select ${n}`);
  return { ...n, options: Ie(n.options) };
}) : Array.isArray(e) ? e.map((n) => ({ value: n, label: n })) : typeof e == "object" ? Object.keys(e).map((n) => ({
  value: n,
  label: e[n]
})) : e, He = () => /* @__PURE__ */ V("span", { className: "mdc-select__dropdown-icon", children: [
  /* @__PURE__ */ c(
    he,
    {
      className: "mdc-select__dropdown-icon-inactive",
      icon: "arrow_drop_down"
    }
  ),
  /* @__PURE__ */ c(he, { className: "mdc-select__dropdown-icon-active", icon: "arrow_drop_up" })
] });
function Pe(e) {
  const {
    selectOptions: n,
    placeholder: f = "",
    children: s,
    elementRef: m,
    open: a,
    label: h,
    ...C
  } = e, y = ({
    label: i,
    option: p,
    index: g
  }) => /* @__PURE__ */ c("option", { ...p, value: p.value, children: i }, g), b = !e.value && !e.defaultValue;
  return /* @__PURE__ */ V(
    "select",
    {
      tabIndex: 0,
      ...C,
      ref: m,
      className: `rmwc-select__native-control${C.className ? ` ${C.className}` : ""}`,
      children: [
        (e.placeholder !== void 0 || b) && /* @__PURE__ */ c("option", { value: "", disabled: b, children: f }),
        !!n && n.map(
          ({ label: i, options: p, ...g }, u) => p ? /* @__PURE__ */ c("optgroup", { label: i, children: p.map(
            ({ label: W, ...M }, E) => y({
              label: W,
              option: M,
              index: E
            })
          ) }, u) : y({
            label: i,
            option: g,
            index: u
          })
        ),
        s
      ]
    }
  );
}
const $e = function(e) {
  return /* @__PURE__ */ c(fe, { ...e });
}, Ke = ve.forwardRef(
  (e, n) => {
    const {
      selectOptions: f,
      menuApiRef: s,
      value: m,
      placeholder: a,
      children: h,
      selectedIndex: C,
      ...y
    } = e;
    let b = 0;
    const i = re(e, ["mdc-select__menu"]), p = ({
      label: g,
      option: u
    }) => (b += 1, /* @__PURE__ */ c(
      pe,
      {
        activated: m !== void 0 ? u.value === m : b - 1 === C,
        ...u,
        "data-value": u.value,
        children: /* @__PURE__ */ c("span", { className: "mdc-deprecated-list-item__text", children: g })
      },
      `${g}-${u.value}`
    ));
    return /* @__PURE__ */ V(
      Ne,
      {
        ...y,
        ref: n,
        apiRef: s,
        className: i,
        focusOnOpen: !0,
        children: [
          !!e.placeholder && /* @__PURE__ */ c(
            pe,
            {
              selected: b - 1 === C,
              "data-value": "",
              theme: "textDisabledOnBackground",
              children: /* @__PURE__ */ c("span", { className: "mdc-deprecated-list-item__text", children: a })
            }
          ),
          f.map(
            ({ label: g, options: u, ...W }, M) => u ? /* @__PURE__ */ V(Ee, { children: [
              g && /* @__PURE__ */ c(Te, { theme: "textDisabledOnBackground", children: g }),
              /* @__PURE__ */ c(we, { children: u.map(
                ({ label: E, ...v }) => p({
                  label: E,
                  option: v
                })
              ) }),
              M < f.length - 1 && /* @__PURE__ */ c(je, {})
            ] }, M) : p({ label: g, option: W })
          ),
          h
        ]
      }
    );
  }
), Xe = ({
  enhanced: e,
  children: n
}) => e ? /* @__PURE__ */ c(Ve, { children: n }) : /* @__PURE__ */ c(be, { children: n }), rt = Ae(function(n, f) {
  const {
    placeholder: s,
    children: m,
    value: a,
    outlined: h,
    label: C = "",
    options: y = [],
    rootProps: b = {},
    enhanced: i,
    icon: p,
    onChange: g,
    onFocus: u,
    onBlur: W,
    onKeyDown: M,
    invalid: E,
    inputRef: v,
    helpText: O,
    foundationRef: U,
    ...Q
  } = n, H = Ie(y), {
    rootEl: ce,
    anchorEl: J,
    notchWidth: le,
    menuOpen: T,
    selectedTextContent: l,
    lineRippleActive: Y,
    lineRippleCenter: x,
    floatLabel: P,
    setFloatingLabel: oe,
    setNativeControl: $,
    setLeadingIcon: ae,
    selectedIndex: K,
    setMenu: se,
    handleFocus: Z,
    handleBlur: j,
    handleClick: de,
    handleChange: ue,
    handleKeydown: ie,
    handleMenuClosed: ee,
    handleMenuOpened: te,
    handleMenuSelected: S
  } = Be(n), G = ye("select", n), t = G + "-label", R = re(n, [
    "mdc-select",
    "rmwc-select__default-width",
    {
      "mdc-select--outlined": !!h,
      "mdc-select--filled": !h,
      "mdc-select--required": !!n.required,
      "mdc-select--invalid": !!E,
      "mdc-select--with-leading-icon": !!p,
      "mdc-select--no-label": !C
    }
  ]), L = typeof i == "object" ? i : {}, k = a !== void 0 ? void 0 : n.defaultValue || "", _ = /* @__PURE__ */ c(
    Oe,
    {
      float: P,
      apiRef: oe,
      htmlFor: G,
      id: t,
      children: C
    }
  ), X = () => {
    if (!!!O)
      return null;
    const ne = typeof O == "object" && !ve.isValidElement(O);
    return O && ne ? /* @__PURE__ */ c(Ce, { ...O }) : /* @__PURE__ */ c(Ce, { children: O });
  };
  return /* @__PURE__ */ V(Xe, { enhanced: i, children: [
    /* @__PURE__ */ V(fe, { ...b, element: ce, ref: f, className: R, children: [
      /* @__PURE__ */ V(
        $e,
        {
          className: "mdc-select__anchor",
          role: "button",
          "aria-haspopup": "listbox",
          "aria-labelledby": t,
          element: J,
          onFocus: Z,
          onBlur: j,
          onClick: de,
          onKeyDown: ie,
          onChange: ue,
          tabIndex: i ? void 0 : -1,
          children: [
            !!p && /* @__PURE__ */ c(We, { apiRef: ae, icon: p }),
            h ? /* @__PURE__ */ c(Fe, { notch: le, children: _ }) : /* @__PURE__ */ V(be, { children: [
              /* @__PURE__ */ c(_e, { active: Y, center: x }),
              _
            ] }),
            /* @__PURE__ */ c("span", { className: "mdc-select__selected-text-container", children: /* @__PURE__ */ c("span", { className: "mdc-select__selected-text", children: l }) }),
            /* @__PURE__ */ c(He, {}),
            !i && /* @__PURE__ */ c(
              Pe,
              {
                ...Q,
                id: G,
                value: a,
                children: m,
                defaultValue: k,
                placeholder: s,
                selectOptions: H,
                elementRef: $,
                onFocus: Z,
                onBlur: (A) => {
                  j(A), ee();
                },
                onChange: (A) => {
                  S(A.currentTarget.selectedIndex);
                }
              }
            )
          ]
        }
      ),
      i && /* @__PURE__ */ c(
        Ke,
        {
          ...Q,
          ...L,
          ref: f,
          anchorCorner: "bottomStart",
          defaultValue: k,
          placeholder: s,
          open: T,
          onClose: ee,
          onOpen: te,
          onSelect: (A) => {
            S(A.detail.index);
          },
          selectOptions: H,
          value: a,
          selectedIndex: K,
          menuApiRef: se,
          children: m
        }
      )
    ] }),
    X()
  ] });
}), Ce = Ae(function(n, f) {
  const { persistent: s, validationMsg: m, ...a } = n, h = re(n, [
    "mdc-select-helper-text",
    {
      "mdc-select-helper-text--persistent": s,
      "mdc-select-helper-text--validation-msg": m
    }
  ]);
  return /* @__PURE__ */ c(fe, { tag: "p", ...a, className: h, ref: f });
});
export {
  rt as Select,
  Ce as SelectHelperText
};
